import Note, { NoteProps } from './Note';

export type NoteProps = NoteProps;

export default Note;
